import { render, staticRenderFns } from "./MobilePhoneIcon.vue?vue&type=template&id=2c0cdd3c"
import script from "./MobilePhoneIcon.vue?vue&type=script&lang=js"
export * from "./MobilePhoneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports